/* Cloud Slides DR advertorial — sticky hero CTA + lazy video, isolated to this page's markup only. */
(function () {
  function initStickyCta() {
    var sentinel = document.querySelector('[data-cloudslidesdr-sticky-trigger]');
    var stickyBar = document.querySelector('[data-cloudslidesdr-sticky-bar]');
    if (!sentinel || !stickyBar || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var pastTrigger = entries[0].boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-active', pastTrigger);
      },
      { threshold: 0 }
    );

    observer.observe(sentinel);
  }

  function initLazyVideos() {
    var videos = document.querySelectorAll('[data-cloudslidesdr-lazy-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        loadVideo(video);
        video.play().catch(function () {});
      });
      return;
    }

    function loadVideo(video) {
      if (video.dataset.loaded === 'true') return;
      var sources = video.querySelectorAll('source[data-src]');
      sources.forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
      video.dataset.loaded = 'true';
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            loadVideo(video);
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '300px 0px' }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  function init() {
    initStickyCta();
    initLazyVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
